import script from "./menuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./menuComponent.vue?vue&type=script&setup=true&lang=js"

import "./menuComponent.vue?vue&type=style&index=0&id=a3b321d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3b321d0"]])

export default __exports__